import {
	CHECK_EMAIL_OR_USERNAME_EXISTS_QUERY,
	CREATE_COMPANY_HOTEL_PROPERTIES_MUTATION, CREATE_PARITY_COMPANY_HOTEL_MUTATION,
	FINISH_UPDATE_MARKET_STATE_FOR_COMPANY,
	PROFILE_VERIFICATION_PENDING_BY_ID_QUERY,
	PROFILE_VERIFICATION_PENDING_BY_USERNAME_QUERY,
	REGISTER_COMPANY_MUTATION,
	REGISTER_MUTATION,
	RUN_ENRICH_COMPANY_HOTELS,
	RUN_RANKING_COMPANY_HOTELS,
	RUN_UPDATE_MARKET_STATE_FOR_COMPANY,
	SELECT_SUBSCRIPTION_PLAN_MUTATION,
	VERIFY_PROFILE_MUTATION,
} from '@app/model/registration/service/RegistrationGraphQLQueries';
import Return from '@app/model/_common/Return';
import FormInputValidator from '@app/component/form/input/FormInputValidator';
import { useTranslation } from '@app/component/translation/Translation';
import RegistrationInput from '@app/model/registration/input/RegistrationInput';
import ProfileVerification from '@app/model/profile/ProfileVerification';
import Principal from '@app/model/authentication/Principal';
import CompleteRegistrationInput from '@app/model/registration/input/CompleteRegistrationInput';
import CompanyRegistrationInput from '@app/model/registration/input/CompanyRegistrationInput';
import _get from 'lodash/get';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import ProcessRequestExecutionState from '@app/model/process-request/ProcessRequestExecutionState';


class RegistrationService {
    public static checkEmailOrUsernameExists(): FormInputValidator {
        const {t} = useTranslation();

        return {
            //@ts-ignore
            check: async (username: string): string | boolean => {
                let result: string | boolean = true;
                await GraphQLExecutor.graphQLClient.request<{ checkEmailOrUsernameExists: Return }, {
                    username: string
                }>(CHECK_EMAIL_OR_USERNAME_EXISTS_QUERY.gql, {username})
                    .then(response => {
                        const r = _get(response, CHECK_EMAIL_OR_USERNAME_EXISTS_QUERY.name);
                        // @ts-ignore
                        if (!!r && !r.success) return result = t(r.exception);
                        return undefined;
                    }).catch((error)=>result = t(error))
                return result;
            }
        }
    }

    public static register(input: RegistrationInput) {
        return GraphQLExecutor.execute<Return>(REGISTER_MUTATION, {input})
    }

    public static registerCompany(input: CompanyRegistrationInput) {
        return GraphQLExecutor.execute<Principal>(REGISTER_COMPANY_MUTATION, {input})
    }

    public static profileVerificationPendingByUsername(username: string) {
        return GraphQLExecutor.execute<ProfileVerification>(PROFILE_VERIFICATION_PENDING_BY_USERNAME_QUERY, {username})
    }

    public static profileVerificationPendingById(id: number) {
        return GraphQLExecutor.execute<ProfileVerification>(PROFILE_VERIFICATION_PENDING_BY_ID_QUERY, {id})
    }

    public static verifyProfile(verificationKey: string) {
        return GraphQLExecutor.execute<Return>(VERIFY_PROFILE_MUTATION, {verificationKey})
    }

    public static createCompanyHotelProperties(input: CompleteRegistrationInput) {
        return GraphQLExecutor.execute<Principal>(CREATE_COMPANY_HOTEL_PROPERTIES_MUTATION, {input})
    }


    public static createParityCompanyHotel(variables: {hotelId: number, webhotelierId: string}) {
        return GraphQLExecutor.execute<Principal>(CREATE_PARITY_COMPANY_HOTEL_MUTATION, variables)
    }

    public static runEnrichCompanyHotels() {
        return GraphQLExecutor.execute<ProcessRequestExecutionState>(RUN_ENRICH_COMPANY_HOTELS)
    }

    public static runRankingCompanyHotels() {
        return GraphQLExecutor.execute<ProcessRequestExecutionState>(RUN_RANKING_COMPANY_HOTELS)
    }

    public static runMarketStateUpdateForCompany() {
        return GraphQLExecutor.execute<ProcessRequestExecutionState>(RUN_UPDATE_MARKET_STATE_FOR_COMPANY)
    }

    public static finishMarketStateUpdateForCompany() {
        return GraphQLExecutor.execute<Principal>(FINISH_UPDATE_MARKET_STATE_FOR_COMPANY)
    }

    public static selectSubscriptionPlan() {
        return GraphQLExecutor.execute<Principal>(SELECT_SUBSCRIPTION_PLAN_MUTATION)
    }
}

export default RegistrationService;
